import Splide from '@splidejs/splide';

const Project = () => {
    const section = document.querySelector('.project-template-wrapper .project-details .splide');

    if (!section) return;

    const contactSplide = new Splide( section, {
        perPage: 1,
        gap: '16px',
        pagination: false,  
        // arrows: false,
        padding: { right: '25%' },
    } ).mount( {} );
}

export default Project;